import React from "react";
import PropTypes from "prop-types";
import useLocaleDateFormatter from "../../../hooks/useLocaleDateFormatter";
import classNames from "../../../utils/classNames";
import { getDateSeparatorMetadata } from "../../../utils/dateLabel";
import "./index.scss";

const normalizeText = (value) => (typeof value === "string" ? value.trim() : "");

const MessageDateSeparator = ({
    date = "",
    variant = "inline",
    label = "",
    isoDate = "",
    displayLabel = "",
    className = "",
}) => {
    const { formatDate } = useLocaleDateFormatter();
    const metadata = getDateSeparatorMetadata(date, formatDate);

    const resolvedIsoDate = normalizeText(isoDate) || metadata.isoDate || "";
    const resolvedDataLabel = normalizeText(label) || metadata.label || metadata.displayLabel || "";
    const resolvedDisplayLabel = normalizeText(displayLabel) || metadata.displayLabel || resolvedDataLabel;

    if (!resolvedDisplayLabel) {
        return null;
    }

    return (
        <div
            className={classNames(
                "message-date-separator",
                `message-date-separator--${variant}`,
                className
            )}
            data-date={resolvedDataLabel || resolvedDisplayLabel}
            data-date-label={resolvedDataLabel || resolvedDisplayLabel}
            data-date-iso={resolvedIsoDate || undefined}
        >
            <span className="message-date-separator__pill">{resolvedDisplayLabel}</span>
        </div>
    );
};

MessageDateSeparator.propTypes = {
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
    variant: PropTypes.oneOf(["inline", "sticky"]),
    label: PropTypes.string,
    isoDate: PropTypes.string,
    displayLabel: PropTypes.string,
    className: PropTypes.string,
};

export default MessageDateSeparator;
